import React, { useEffect, useState } from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { PermissionChangeNotification } from '../ui/PermissionChangeNotification';

export const PermissionChangeListener: React.FC = () => {
  const { 
    permissionChangeNotification, 
    clearPermissionChangeNotification,
    isWebSocketConnected 
  } = usePermissions();
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    if (permissionChangeNotification) {
      setShowNotification(true);
      
      // Auto-cerrar después de 10 segundos
      const timer = setTimeout(() => {
        handleClose();
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [permissionChangeNotification]);

  const handleClose = () => {
    setShowNotification(false);
    setTimeout(() => {
      clearPermissionChangeNotification();
    }, 300);
  };


  // Solo mostrar si hay una notificación y WebSocket está conectado
  if (!isWebSocketConnected) {
    return null;
  }

  return (
    <PermissionChangeNotification
      isOpen={showNotification}
      event={permissionChangeNotification}
      onClose={handleClose}
    />
  );
};